import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  border-bottom:1px solid #f2f2f2;
`;

export const OptionWrapper = styled.span`
  float:right;
`;

export const Option = styled.span`
  float:left;  
  margin-left:10px;
  height:20px;
  line-height:20px;  
  font-size: 13px;
  font-weight:normal;
  
  &:before {
    float:left;
    margin:8px 5px 0 0;
    content:'';
    width:4px;
    height:4px;
    border-radius:100%;
    background-color:#111;
  }

  ${(props) =>
    props.isSelected &&
    css`
      color: #ee1a21;
      &:before {
        background-color:#ee1a21;
      }
    `}
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing:0;
  table-layout: fixed;
  width: 100%;
      
  & > tbody > tr > th {
    height: 36px;
    font-size: 12px;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
  }
  & > tbody td {
    height: 42px;
    font-size: 13px;
    text-align: center;
    border-bottom: 1px solid #fafafa;
  }
  & .team {
    border-right:1px solid #f2f2f2;
  }
  
  
`;

export const SubTableCell = styled.td`
  overflow-x: scroll;
  padding: 0;
  vertical-align: top;
`;
export const TeamCell = styled.div`
    flex: 1;
    display: flex;
    position: relative;
    height: 42px;
    align-items: center;
    
  & > span {
    display: -webkit-box;
    margin:0 10px 0 5px;
    width: 100%;
    -webkit-box-orient: vertical;
    word-break: break-all;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 13px;
    text-align: left;    
  }
  & > img {
    display:block;;
    width:20px;
    height:20px;
  }
`;

export const SubTable = styled.table`
  margin: 0;
  padding: 0;
  border-collapse: separate;
  border-spacing:0;
  table-layout: fixed;
  width: 100%;
  background-color: #fff;
  & th {
    font-size: 12px;
    height: 36px;
    border-bottom: 1px solid #f2f2f2;
  }
  & td {
    font-size: 13px;
    height: 38px;
  }
  & th:nth-child(1) {
    font-weight:bold;
  }
  & td:nth-child(1) {
    font-weight:bold;
  }
`;
